// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"10ae1bc3","362":"37633854","407":"677ccd27","453":"53788d34","660":"d97cd366"}[chunkId] + ".chunk.js";
};